<template>
  <v-list
    dense
    nav
  >
    <v-list-item
      v-for="menuItem in items"
      :key="menuItem.name"
    >
      <v-list-item-content>
        <v-btn text class="mt-5" block color="primary" dark
          :to="{ name: menuItem.pathName }"
        >
          <v-icon class="mr-2" color="secondary" v-if="menuItem.icon">{{ menuItem.icon }}</v-icon>
          {{ $t(menuItem.name) }}
        </v-btn>
      </v-list-item-content>
    </v-list-item>
  </v-list>
</template>

<script>
import { mdiHome } from '@mdi/js';
import menuItems from '../menuItems';

export default {
  mixins: [menuItems],
  computed: {
    items() {
      const items = this.menuItems;
      items.unshift({
        name: 'menu.home', icon: mdiHome, pathName: 'AuthHome',
      });
      return items;
    },
  },
};
</script>

<style scoped>
.v-list-item__content > a {
  justify-content: left;
}
</style>
